import { defineComponent as _defineComponent } from 'vue'
import {
  PropType, ref, watch,
} from 'vue';
import { Cropper } from 'vue-advanced-cropper';
import { v4 as uuidv4 } from 'uuid';
import showConfirmationDialog from '@/components/dialogs/confirmation-dialog';
import i18n from '@/plugins/i18n';
import { TranslateResult } from 'vue-i18n';
import Pica from 'pica';
// eslint-disable-next-line import/no-unresolved
import 'vue-advanced-cropper/dist/style.css';

interface UploadedFile {
  file: File;
}

enum UploadDialogMode {
  PREVIEW,
  UPLOAD_FORM,
  EDIT
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ImageUploadDialog',
  props: {
    title: { type: [String, Object] as PropType<string|TranslateResult>, required: false, default: '' },
    imageSrc: { type: String, required: false, default: '' },
    filenamePrefix: { type: String, required: false, default: 'img' },
    helpLabel: { type: [String, Object] as PropType<string|TranslateResult>, required: true },
    deleteConfirmationLabel: { type: [String, Object] as PropType<string|TranslateResult>, required: true },
    stencilProps: { type: Object, required: false, default: () => {} },
    maxWidth: { type: Number, required: false, default: 0 },
  },
  emits: ['close', 'change'],
  setup(__props, { emit }) {

const props = __props;





const cropperRef = ref<InstanceType<typeof Cropper>>();

const previewImage = ref('');

const fileRecords = ref([] as UploadedFile[]);

const mode = ref(props.imageSrc.length === 0 ? UploadDialogMode.UPLOAD_FORM : UploadDialogMode.PREVIEW);

watch(fileRecords, () => {
  if (!fileRecords.value || fileRecords.value.length === 0) {
    return;
  }
  previewImage.value = URL.createObjectURL(fileRecords.value[0].file);
  mode.value = UploadDialogMode.EDIT;
});

//

const save = async () => {
  if (cropperRef.value === null) { return; }

  const { canvas } = cropperRef.value.getResult();
  if (!canvas) return;

  const shouldResize = props.maxWidth !== 0 && canvas.width > props.maxWidth;

  const fileName = `${props.filenamePrefix}-${uuidv4()}.png`;

  console.log('canvas acquired');

  const getBlob = () => {
    if (shouldResize) {
      // if we need to resize
      const ratio = canvas.width / canvas.height;
      const rCanvas = document.createElement('canvas');
      rCanvas.width = props.maxWidth;
      rCanvas.height = props.maxWidth / ratio;

      console.log(`Resizing (${canvas.width},${canvas.height}) to (${rCanvas.width}, ${rCanvas.height}})`);

      const pica = new Pica();
      return pica.resize(canvas, rCanvas).then((result: HTMLCanvasElement) => pica.toBlob(result, 'image/png'));
    }
    // otherwise pull directly from cropper canvas
    console.log(`Not Resizing (${canvas.width},${canvas.height}) under ${props.maxWidth} or disabled.`);
    return new Promise<Blob>((resolve) => {
      canvas.toBlob((blob: Blob) => {
        resolve(blob);
      });
    });
  };

  const blob = await getBlob();
  if (!blob) { return; }
  const file = new File([blob], fileName, { type: 'image/png' });
  emit('change', file);
};

const replaceImage = () => {
  mode.value = UploadDialogMode.UPLOAD_FORM;
};

const deleteImage = () => {
  showConfirmationDialog(
    undefined,
    props.deleteConfirmationLabel as string,
    { title: i18n.tc('button.yes'), action: () => { emit('change', null); } },
    { title: i18n.tc('button.cancel') },
  );
};

const close = () => {
  emit('close');
};


return { __sfc: true,UploadDialogMode, props, emit, cropperRef, previewImage, fileRecords, mode, save, replaceImage, deleteImage, close, Cropper }
}

})